module.exports = __webpack_public_path__ + "fonts/Lato-Bold.784bf58.woff2";